import {axiosAPI} from "./API";
import { UserService } from "./UserService";

// Singleton for interacting with mqtt streams
class _SubscribeService {

    socket: WebSocket;

    public connect = async (): Promise<WebSocket> => {

        let url = axiosAPI.defaults.baseURL; // take url from axios
        url = url.replace("http://", "ws://"); // replace url prefix
        url = url.replace("https://", "wss://"); // replace url prefix
        url += "/stream?user=" + UserService.oktaUserInfo.sub; // add user param
        url += "&token=" + UserService.oktaUserInfo.token; // add token param

        this.socket = new WebSocket(url);

        this.socket.addEventListener("open", event => {
            console.log("connected to events");
        });

        this.socket.addEventListener("close", event => {
            console.log("disconnected from events");
        });

        return this.socket;
    }

    public disconnect = () => {
        this.socket?.close();
    }

    public subscribe = (topic: string, thingIDs: string[]): Promise<any> => {
        let payload = {
            user: UserService.oktaUserInfo.sub, 
            manualTopic: topic, 
            thingIDs: thingIDs
        }

        const p = axiosAPI.post<any>('/subscribe', payload)
            .then((resp) => {

            });

        p.catch((err) => {
            console.error('Error subscribing to topic: ', err);
        });

        return p;
    }

    public unsubscribe = (topic: string, thingIDs: string[]): Promise<any> => {
        let payload = {
            user: UserService.oktaUserInfo.sub, 
            manualTopic: topic, 
            thingIDs: thingIDs
        }

        const p = axiosAPI.post<any>('/unsubscribe', payload)
            .then((resp) => {

            });

        p.catch((err) => {
            console.error('Error unsubscribing to topic: ', err);
        });

        return p;
    }
}

export const SubscribeService = new _SubscribeService();
